import React, { Fragment, useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { Offcanvas, Form } from 'react-bootstrap';
import { FaUser, FaSun, FaMoon, FaLeaf } from 'react-icons/fa';

import { Navigation } from 'components';
import navigationConfig from './navigationConfig';

import getInitials from 'utils/getInitials';

const NavBar = (props) => {
  const { openMobile, onMobileClose, className, ...rest } = props;

  const [name, setName] = useState();
  const [companyName, setCompanyName] = useState();
  const [darkMode, setDarkMode] = useState(() => {
    // Verifica se existe uma preferência salva no localStorage
    const savedTheme = localStorage.getItem('theme');
    return savedTheme ? savedTheme === 'dark' : false;
  });

  useEffect(() => {
    if (localStorage.getItem('userData')) {
      const { name, companyName } = JSON.parse(localStorage.getItem('userData'));
      setName(name);
      setCompanyName(companyName);
    }
    
    // Aplica o tema atual ao carregar o componente
    document.body.classList.toggle('dark-theme', darkMode);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggleTheme = () => {
    const newMode = !darkMode;
    setDarkMode(newMode);
    localStorage.setItem('theme', newMode ? 'dark' : 'light');
    
    document.body.classList.toggle('dark-theme', newMode);
  };

  const navbarContent = (
    <div className="p-3">
      {/* Perfil do usuário */}
      <div className="d-flex flex-column align-items-center mb-4">
        <div 
          className="rounded-circle d-flex align-items-center justify-content-center mb-3" 
          style={{
            width: 60,
            height: 60,
            backgroundColor: 'var(--brand-dark-green)',
            boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
            border: '3px solid var(--brand-light-green)',
            color: 'white'
          }}
        >
          {name ? getInitials(name) : <FaUser size={24} />}
        </div>
        
        <h6 className="fw-bold mb-0" style={{ color: 'var(--navbar-text)' }}>{name}</h6>
        <div className="text-muted small mb-3">{companyName}</div>
        
        {/* Seletor de Tema */}
        <div className="d-flex align-items-center justify-content-center p-2 rounded-pill" 
             style={{ backgroundColor: 'var(--navbar-hover-bg)', width: '150px', minWidth: '150px' }}>
          <FaSun className="me-2" style={{ color: 'var(--warning-color)' }} size={14} />
          <Form.Check
            type="switch"
            id="theme-switch"
            checked={darkMode}
            onChange={toggleTheme}
            className="custom-theme-switch"
          />
          <FaMoon className="ms-2" style={{ color: 'var(--navbar-text)' }} size={14} />
        </div>
      </div>

      <div style={{ height: '1px', backgroundColor: 'var(--card-border)', margin: '0.5rem 0 1.5rem' }} />
      
      {/* Menu de navegação */}
      <div className="overflow-auto pb-5" style={{ maxHeight: 'calc(100vh - 200px)' }}>
        {navigationConfig && navigationConfig.map((list) => (
          <Navigation
            component="div"
            key={list.title ? list.title : ''}
            pages={list.pages}
            title={list.title}
          />
        ))}
      </div>
    </div>
  );

  return (
    <Fragment>
      <Offcanvas 
        show={openMobile} 
        onHide={onMobileClose} 
        className="d-lg-none"
        placement="start"
        style={{ backgroundColor: 'var(--navbar-bg)', width: '230px', minWidth: '230px' }}
      >
        <Offcanvas.Body className="p-0 overflow-hidden">
          {navbarContent}
        </Offcanvas.Body>
      </Offcanvas>
      
      <div 
        {...rest} 
        className={clsx('h-100 d-none d-lg-block overflow-hidden', className)} 
        style={{ 
          backgroundColor: 'var(--navbar-bg)',
          width: '230px',
          minWidth: '230px',
          flexShrink: 0
        }}
      >
        {navbarContent}
      </div>
    </Fragment>
  );
};

NavBar.propTypes = {
  className: PropTypes.string,
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
};

export default NavBar;
